import styled from 'styled-components';
import { ImageSectionStyled } from '../ImageSectionStyled';
import { rem } from 'polished';

export const ImageSectionStyledOV = styled(ImageSectionStyled)`
    .react-multiple-carousel__arrow {
        border-width: 2px;
    }
    
    .delivery {
        margin-top: ${rem(20)};
    }
    
    .dealer {
        .address {
            color: ${({ theme }) => theme.colors.black};
        }
    }
`;
